import React from 'react';

const BiblicalTopicsModal = ({ isOpen, onClose, onSelectTopic }) => {
  if (!isOpen) return null;

  const topics = [
    // 12 Laws of Attraction & Transformation (10 topics)
    { id: 1, title: "How Beliefs Shape Thoughts", prompt: "What does the Bible say about how beliefs affect my thoughts and mental foundations?" },
    { id: 2, title: "Choosing Freedom", prompt: "How does choosing freedom attract enabling beliefs according to scripture?" },
    { id: 3, title: "Thoughts Attracting Ideas", prompt: "What does the Bible teach about how powerful thoughts generate transformative ideas?" },
    { id: 4, title: "Attracting Happiness", prompt: "How do I attract happiness according to biblical principles?" },
    { id: 5, title: "Feelings & Emotions Connection", prompt: "What is the spiritual connection between feelings and emotions in scripture?" },
    { id: 6, title: "Emotions & Commitment", prompt: "How do emotions attract commitment and purposeful action biblically?" },
    { id: 7, title: "Commitment to Oneness", prompt: "How does commitment lead to oneness with God according to the Bible?" },
    { id: 8, title: "Actions & Behavior", prompt: "What does scripture teach about how actions attract and shape behavior?" },
    { id: 9, title: "Creating Harmony", prompt: "How does behavior create harmony in life according to biblical wisdom?" },
    { id: 10, title: "Accountability for Outcomes", prompt: "What is the biblical path from harmony to accountability for life outcomes?" },

    // Mind, Body & Spirit - Tripartite Being (8 topics)
    { id: 11, title: "Tripartite Being", prompt: "What does it mean to be a tripartite being - mind, body, and spirit?" },
    { id: 12, title: "Mind, Body, Spirit Integration", prompt: "How do mind, body, and spirit work together for spiritual transformation?" },
    { id: 13, title: "Body & Spirit Relationship", prompt: "What does scripture say about the relationship between body and spirit?" },
    { id: 14, title: "Aligning Mind with God", prompt: "How do I align my mind with God's truth according to the Bible?" },
    { id: 15, title: "Human Magnificence", prompt: "What is the biblical view of human magnificence and divine design?" },
    { id: 16, title: "Child of God Identity", prompt: "How does the Bible describe being a child of God and what that means?" },
    { id: 17, title: "Living Abundantly", prompt: "What does scripture teach about being human and living an abundant life?" },
    { id: 18, title: "Integrating Spirit into Daily Life", prompt: "How do I integrate spiritual truth into my physical daily life?" },

    // Power, Flow & Clarity - Three Worlds (10 topics)
    { id: 19, title: "Accessing Divine Power", prompt: "How do I access divine power in my daily life according to scripture?" },
    { id: 20, title: "Eternal vs Internal World", prompt: "What is the difference between the eternal world and internal world spiritually?" },
    { id: 21, title: "Beliefs, Feelings & Actions", prompt: "How do beliefs, feelings, and actions work together spiritually?" },
    { id: 22, title: "Alignment, Resonance & Harmony", prompt: "What does scripture say about alignment, resonance, and harmony with God?" },
    { id: 23, title: "Awareness to Utilization", prompt: "How do I move from awareness to focus to utilization in my faith?" },
    { id: 24, title: "Freedom, Happiness & Oneness", prompt: "What is the biblical path to experiencing freedom, happiness, and oneness?" },
    { id: 25, title: "Three Divine Relationships", prompt: "How do I strengthen my relationship with God, myself, and others biblically?" },
    { id: 26, title: "Receiving & Processing Truth", prompt: "What does the Bible teach about receiving, processing, and displaying divine truth?" },
    { id: 27, title: "Thoughts, Emotions & Behaviors", prompt: "How do thoughts, emotions, and behaviors manifest divine truth in my life?" },
    { id: 28, title: "Past, Present & Future", prompt: "What is the spiritual significance of past, present, and future according to scripture?" },

    // Transformation & Spiritual Growth (7 topics)
    { id: 29, title: "Freedom Transforms Relationship", prompt: "How does choosing freedom transform my relationship with God?" },
    { id: 30, title: "Inner Transformation Process", prompt: "What is the biblical process of inner transformation and renewal?" },
    { id: 31, title: "Demonstrating Wisdom Daily", prompt: "How do I demonstrate God's wisdom in practical daily life?" },
    { id: 32, title: "Spiritual Alignment", prompt: "What does scripture teach about achieving spiritual alignment with God's will?" },
    { id: 33, title: "Cultivating Inner Happiness", prompt: "How do I cultivate lasting happiness from within according to the Bible?" },
    { id: 34, title: "Understanding to Demonstration", prompt: "What is the path from understanding divine truth to demonstrating it?" },
    { id: 35, title: "Focus Through Commitment", prompt: "How do feelings, emotions, and commitment create spiritual focus?" },

    // Deep Spiritual Concepts (5 topics)
    { id: 36, title: "Accessing Divine Wisdom", prompt: "What does the Bible say about accessing the mind and wisdom of God?" },
    { id: 37, title: "Grace, Favor & Mercy", prompt: "How do grace, favor, and mercy work together in the spiritual life?" },
    { id: 38, title: "True Worship", prompt: "What is the biblical meaning of true worship in spirit and truth?" },
    { id: 39, title: "Simultaneous Freedom & Oneness", prompt: "How do I experience freedom, happiness, and oneness simultaneously?" },
    { id: 40, title: "Three Worlds of Existence", prompt: "What does scripture reveal about the eternal, internal, and external dimensions of life?" },

    // Emit-Exclusive Deep Transformation (10 topics - Unique to Emit's RAG)
    { id: 41, title: "Correcting Misalignment", prompt: "When I feel spiritually off-track, what is the biblical correction process to realign with God?" },
    { id: 42, title: "Energy & Information", prompt: "What does the Bible teach about understanding energy as information and the beginning of ideas?" },
    { id: 43, title: "Streaming Divine Energy", prompt: "How do I stream, transform, and share divine energy according to scripture?" },
    { id: 44, title: "Imagination & Divine Reasoning", prompt: "What is the spiritual role of imagination and reasoning in connecting with God?" },
    { id: 45, title: "Intuition & Perception", prompt: "How do intuition and perception help me discern God's guidance biblically?" },
    { id: 46, title: "Free Will & Memory", prompt: "What does the Bible say about the relationship between free will, memory, and spiritual growth?" },
    { id: 47, title: "Meaning, Purpose & Value", prompt: "How do meaning, purpose, and value connect across my relationship with God, self, and others?" },
    { id: 48, title: "Design, Engineer & Construct", prompt: "What is God's process for designing, engineering, and constructing transformation in my life?" },
    { id: 49, title: "Sovereign Growth Agent", prompt: "How do I become a sovereign growth being and active agent of choice according to scripture?" },
    { id: 50, title: "Great Awakening & Restoration", prompt: "What does the Bible reveal about spiritual awakening, cultural restoration, and renaissance?" }
  ];

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10000,
      padding: '20px'
    }}
    onClick={onClose}>
      <div style={{
        background: 'white',
        borderRadius: '16px',
        maxWidth: '900px',
        width: '100%',
        maxHeight: '85vh',
        overflow: 'hidden',
        boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
        display: 'flex',
        flexDirection: 'column'
      }}
      onClick={(e) => e.stopPropagation()}>
        
        {/* Header */}
        <div style={{
          padding: '24px',
          borderBottom: '1px solid #e5e7eb',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <h2 style={{ margin: 0, color: '#1a202c', fontSize: '1.5rem' }}>
            📖 Explore 50 Biblical Topics
          </h2>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '24px',
              cursor: 'pointer',
              color: '#718096',
              padding: '4px 8px'
            }}
          >
            ×
          </button>
        </div>

        {/* Content */}
        <div style={{
          padding: '24px',
          overflowY: 'auto',
          flex: 1
        }}>
          <p style={{ color: '#718096', marginBottom: '20px', lineHeight: '1.6' }}>
            Select a topic to explore biblical wisdom with Emit. Each topic draws from deep spiritual frameworks to guide your transformation journey.
          </p>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
            gap: '12px'
          }}>
            {topics.map((topic) => (
              <button
                key={topic.id}
                onClick={() => {
                  onSelectTopic(topic.prompt);
                  onClose();
                }}
                style={{
                  padding: '14px',
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  border: 'none',
                  borderRadius: '12px',
                  color: 'white',
                  fontSize: '13px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  textAlign: 'left',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  boxShadow: '0 2px 8px rgba(102, 126, 234, 0.3)'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.5)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(102, 126, 234, 0.3)';
                }}
              >
                {topic.title}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BiblicalTopicsModal;
